import React, { useState } from "react"
import { Link } from "gatsby"
import testData from "../data/cars.json"
import styled from "styled-components"

const FlotaCard = () => {
  // eslint-disable-next-line
  const [data, setData] = useState(testData)

  return (
    <Container>
      {data.map(item => (
        <div className="card" key={item.id}>
          <img className="img" src={`${item.imagehome}`} alt={item.title} />
          <div className="info">
            <h4>{item.title}</h4>
            <p>{item.pxd}</p>
            <p>{item.pxs}</p>
            <Link to="/reserva" className="btn flota-btn">
              Reservar
            </Link>
          </div>
        </div>
      ))}
    </Container>
  )
}

export default FlotaCard

const Container = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;
  color: rgb(160, 160, 159);

  .card {
    margin-top: 3rem;
  }

  .info {
    margin-top: 1.75rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  h4 {
    margin-bottom: 5px;
  }
  p {
    margin-top: 0;
    margin-bottom: 5px;
  }

  .flota-btn {
    margin-top: 1rem;
  }

  @media (min-width: 772px) {
    padding: 0.575rem 0.75rem;
  }
`
